<template>
  <div class="criterio-date-range">
    <span v-if="labelDate" class="criterio-subtitle">{{ labelDate }}</span>
    <v-row>
      <v-col class="py-0 pt-1" align="center">
        <mf-date-range-picker
          label="De - Até"
          :initial-date.sync="initDate"
          :final-date.sync="endDate"
          :min="minDate"
          hide-details
          icon
          @update:initialDate="input(true)"
          @update:finalDate="input(false)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    componentParams: {
      type: String,
      validator: (val) => ['futureOnly', 'date'].includes(val),
    },
  },
  data: () => ({
    initDate: '',
    endDate: '',
    labelDate: '',
  }),

  computed: {
    minDate() {
      return this.componentParams === 'futureOnly' ? DateTime.now().toFormat('yyyy-MM-dd') : ''
    },
  },

  mounted() {
    this.formatInitialValues()
    this.validate(this.initialValue)
  },

  methods: {
    input(isInitialDate) {
      if (isInitialDate) return
      let initDateToSave = DateTime.fromISO(this.initDate).toFormat('yyyyMMdd')
      let endDateToSave = DateTime.fromISO(this.endDate).toFormat('yyyyMMdd')

      this.$emit('input', { currentValue: [initDateToSave, endDateToSave], currentIndex: this.currentIndex })

      this.validate()
    },
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    isValid() {
      return Boolean(this.initDate && this.endDate)
    },

    formatInitialValues() {
      this.initDate = this.initialValue?.[0] ? DateTime.fromFormat(this.initialValue[0], 'yyyyMMdd').toFormat('yyyy-MM-dd') : ''
      this.endDate = this.initialValue?.[1] ? DateTime.fromFormat(this.initialValue[1], 'yyyyMMdd').toFormat('yyyy-MM-dd') : ''
      this.labelDate = this.label ? this.label : ''
    },
  },
}
</script>

<style lang="scss">
.criterio-date-range {
  .input-container {
    margin-right: 15px;
  }
}
</style>
